import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SmallClientChipV2Mobile from "../../SmallClientChipV2Mobile";
import {
  formatCompactNoteType,
  getStylesForNoteType,
} from "./notesContainerCompactMobileHelpers";

function NoteTypeIcon({ noteType }) {
  const iconStyle = {
    fontSize: "40px",
    color: getStylesForNoteType(noteType).color,
  };

  switch (noteType) {
    case "endOfShift":
      return <AccessTimeIcon style={iconStyle} />;
    case "groupNote":
      return <GroupIcon style={iconStyle} />;
    case "handoverNote":
      return <SwapHorizIcon style={iconStyle} />;
    default:
      return null;
  }
}

function NotesContainerCompactMobileListItem(props) {
  const {
    noteType,
    noteDate,
    clientFirstName,
    clientLastName,
    clientPic,
    onOpen,
  } = props;

  const noteStyles = getStylesForNoteType(noteType);
  const hasTypeIcon = ["endOfShift", "groupNote", "handoverNote"].includes(
    noteType
  );
  const noteDateValue = new Date(noteDate);

  return (
    <div
      style={{
        width: "100%",
        height: "80px",
        display: "flex",
        flexDirection: "row",
        borderBottom: "1px solid lightgrey",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f9f9f9")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}
    >
      <div
        style={{ display: "flex", flexDirection: "row", width: "100%" }}
        onClick={onOpen}
      >
        <div
          style={{
            width: "30%",
            height: "80px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            paddingLeft: "0px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "0px",
            }}
          >
            <div
              style={{
                color: "#a3a3a4",
                fontSize: "14px",
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              {noteDateValue
                .toLocaleString("en-US", { month: "short" })
                .toUpperCase()}
            </div>
            <div
              style={{
                color: "black",
                fontSize: "20px",
                lineHeight: "18px",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {noteDateValue.getDate()}
            </div>
            <div
              style={{
                color: "#a3a3a4",
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              {noteDateValue.getFullYear()}
            </div>
          </div>
        </div>

        <div
          style={{
            width: "40%",
            height: "80px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            paddingLeft: hasTypeIcon ? "30px" : "0px",
          }}
        >
          {hasTypeIcon ? (
            <NoteTypeIcon noteType={noteType} />
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                alignContent: "flex-start",
              }}
            >
              <SmallClientChipV2Mobile
                firstName={clientFirstName}
                lastName={clientLastName}
                avatar="1"
                clientPic={clientPic}
              />
            </div>
          )}
        </div>

        <div
          style={{
            width: "30%",
            height: "80px",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "10px",
              backgroundColor: noteStyles.backgroundColor,
              paddingLeft: "7px",
              paddingRight: "7px",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
              alignSelf: "center",
              color: noteStyles.color,
              fontWeight: "500",
              height: "20px",
            }}
          >
            {formatCompactNoteType(noteType)}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotesContainerCompactMobileListItem;
